import type { Theme } from './theme';

/**
 * Farbton eines Status der Szene (Auswahl im Feld „Status“, siehe core defaults): Idee gedämpft, Entwurf Warnung, überarbeitet Info,
 * fertig ok. Eine Stelle für Gliederung, Erzähllinie, Übersichtsfenster und die Fähnchen der Vorschaukarten.
 */
export type StatusTone = 'muted' | 'warn' | 'info' | 'ok';

const TONES: Record<string, StatusTone> = { Idee: 'muted', Entwurf: 'warn', überarbeitet: 'info', fertig: 'ok' };

/** Ton eines Status; null ohne bzw. bei unbekanntem Status */
export const statusTone = (status: string): StatusTone | null => TONES[status] ?? null;

/** Als CSS-Farbe (Design-Token); null ohne bzw. bei unbekanntem Status */
export function statusCss(status: string): string | null {
  const tone = statusTone(status);
  return tone === null ? null : tone === 'muted' ? 'var(--text-muted)' : `var(--${tone})`;
}

/** Als Farbe der Zeichenfläche (aufgelöstes Theme, für SVG); unbekannt: gedämpft */
export function statusThemeColor(status: string, theme: Theme): string {
  const tone = statusTone(status) ?? 'muted';
  return theme[tone];
}
